import en from './en.json'
import ko from './ko.json'
import fr from './fr.json'
import ar from './ar.json'
import yue from './yue.json'
import ch_s from './ch_s.json'
import ch_t from './ch_t.json'
import de from './de.json'
import es from './es.json'
import fa from './fa.json'
import ja from './ja.json'
import pt_br from './pt_br.json'
import vi from './vi.json'


export const dictionaryList = { en, ko, fr, ar, yue, ch_s, ch_t, de, es, fa, ja, pt_br, vi }

export const languageOptions = {
  en: 'English',
  fr: 'Français',
  ko: '한국어',
  ar: 'عربي',
  yue: '粵語',
  ch_s: '简体中文',
  ch_t: '中国传统的',
  de: 'Deutsch',
  es: 'Español',
  fa: 'فارسی',
  ja: '日本語',
  pt_br: 'Português (Brasil)',
  vi: 'Tiếng Việt'
}

export const languageOptionsUSA = {
  en: 'English',
  ko: '한국어'
}
